var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
var StyledSvg = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fill: ", ";\n  flex-shrink: 0;\n"], ["\n  fill: ", ";\n  flex-shrink: 0;\n"])), function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.color.primary;
});
var Base = /** @class */ (function (_super) {
    __extends(Base, _super);
    function Base() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Base.prototype.render = function () {
        var _a = this.props, viewBox = _a.viewBox, size = _a.size, color = _a.color, className = _a.className, children = _a.children;
        return (React.createElement(StyledSvg, { className: className, xmlns: "http://www.w3.org/2000/svg", viewBox: viewBox, width: size, height: size, color: color, preserveAspectRatio: "xMidYMid" }, children));
    };
    Base.defaultProps = {
        size: 20,
        viewBox: "0 0 20 20"
    };
    return Base;
}(PureComponent));
export default Base;
var templateObject_1;
